import React, { Component, Fragment } from 'react';
import { withNamespaces } from "react-i18next";
import { withRouter } from "react-router-dom";
import { Basemap, Fullscreen, Locate, PictureMarker, PointMarker } from "../../../../libs/arcgis";
import { Card, CardBody, Col, Row } from "reactstrap";
import ProblemForm from "./ProblemForm";
import SCarousel from "../../../../shared/SCarousel/SCarousel";
import { convertHex2Array, lcfirst, toUnderscore, ucfirst } from "../../../../utils";
import queryString from "query-string";
import { i18n } from "../../../../config";

class TreeDetails extends Component {

    constructor(props) {
        super(props);

        if (props.cityObject.images) {
            let defaultImageIndex = props.cityObject.images.findIndex(image => image.default);
            this.defaultIndex = (defaultImageIndex > -1) ? defaultImageIndex : 0;
        }
    }

    prepareBaseData = () => {
        let baseData = [];
        let fields = [
            'Puu liik',
            'Puu tüüp',
            'Puu seisund',
            'Puu väärtusklass',
            'Puu erilisus'
        ];

        for (let field of fields) {
            let fieldName = ucfirst(toUnderscore(field));
            let value = this.getCustomFieldValue(fieldName);
            if (value !== null && value !== '') {
                baseData.push({
                    key: fieldName,
                    name: field,
                    value: value
                });
            }
        }

        baseData.splice(1, 0,
            {
                key: 'Liik eesti keeles',
                name: 'Liik eesti keeles',
                value: this.props.cityObject.treeAdditionalFields ? this.props.cityObject.treeAdditionalFields.treeNameEt.label : ''
            }
        );
        baseData.splice(2, 0,
            {
                key: 'Liik ladina keeles',
                name: 'Liik ladina keeles',
                value: this.props.cityObject.treeAdditionalFields ? this.props.cityObject.treeAdditionalFields.treeNameLa.label : ''
            }
        );
        baseData.splice(3, 0,
            {
                key: 'Sort',
                name: 'Sort',
                value: this.props.cityObject.treeAdditionalFields ? this.props.cityObject.treeAdditionalFields.treeSort && this.props.cityObject.treeAdditionalFields.treeSort.label : ''
            }
        );

        baseData.push(
            {
                key: 'City part',
                name: i18n.t('common:fields.cityPart'),
                value: this.props.cityObject.cityPart ? this.props.cityObject.cityPart.name : ''
            },
            {
                key: 'Asukoha kirjeldus',
                name: i18n.t('common:fields.addressNotADS'),
                value: this.props.cityObject.address
            },
        );

        return baseData;
    };

    prepareDetailsData = () => {
        let data = [];
        let fields = [
            'Puu vanus aastates',
            'Puu kõrgus meetrites',
            'Puu tüve läbimõõt, cm',
            'Suurim võra läbimõõt, m',
            'Võra algus, m',
            'Võra algus sõiduteekohal, m',
            'Võra algus kõnnitee kohal, m'
        ];

        for (let field of fields) {
            let fieldName = field.replace(/ meetrites/, ', m');
            let fieldKey = toUnderscore(field.replace(/, m|, cm/, ''));
            fieldKey = fieldKey.indexOf('Puu_') === -1 ? 'Puu_' + lcfirst(fieldKey) : ucfirst(fieldKey);
            let value = this.getCustomFieldValue(fieldKey);
            if (value !== null && value !== '') {
                data.push({
                    key: fieldKey,
                    name: fieldName,
                    value: value,
                    customValue: this.getCustomFieldValue(fieldKey + "_custom"),
                });
            }
        }

        return data;
    };

    prepareJuurestikData = () => {
        let data = [];
        let fields = [
            'Maapind tõstetud',
            'Tihenenud kasvupinnas',
            'Juured paljandunud',
            'Juurestik mehhaaniliselt vigastatud',
            'Juurekael paljandunud',
            'Õõnsused',
            'Lõhed',
            'Lahtine koor',
            'Kaevetööd võra piirides',
            'Juurekaitserest'
        ];

        for (let field of fields) {
            let fieldName = field.replace(/ meetrites/, ', m');
            let fieldKey = toUnderscore(field.replace(/, m|, cm/, ''));
            fieldKey = fieldKey.indexOf('Puu_') === -1 ? 'Puu_' + lcfirst(fieldKey) : ucfirst(fieldKey);
            let value = this.getCustomFieldValue(fieldKey);
            if (value !== null && value !== '') {
                data.push({
                    key: fieldKey,
                    name: fieldName,
                    value: value,
                    customValue: this.getCustomFieldValue(fieldKey + "_custom"),
                });
            }
        }

        return data;
    };

    prepareVoraData = () => {
        let data = [];
        let fields = [
            'Liigile/sordile omane',
            'Ühekülgne',
            'Võra kõrgel ja väike',
            'Ebaühtlane',
            'Soolakahjustuse tunnused',
            'Vormipuu',
            'Tulbastatud',
            'Köndistatud',
            'Ladvatud või ära murdunud',
            'Palju (üle 5) kuivanud oksi',
            'Kuivav latv',
            'Kahjurid',
            'Muud kahjustused',
            'Kuivanud puu'
        ];

        for (let field of fields) {
            let fieldName = field.replace(/ meetrites/, ', m');
            let fieldKey = toUnderscore(field.replace(/, m|, cm/, ''));
            fieldKey = fieldKey.indexOf('Puu_') === -1 ? 'Puu_' + lcfirst(fieldKey) : ucfirst(fieldKey);
            let value = this.getCustomFieldValue(fieldKey);
            if (value !== null && value !== '') {
                data.push({
                    key: fieldKey,
                    name: fieldName,
                    value: value,
                    customValue: this.getCustomFieldValue(fieldKey + "_custom"),
                });
            }
        }

        return data;
    };

    prepareTuviData = () => {
        let data = [];
        let fields = [
            'Kaldus',
            'Liiga pikk ja peenike',
            'Mitmeharuline',
            'Õõnsused (tüvi)',
            'Lõhed (tüvi)',
            'Seene viljakehad',
            'Lahtine koor (tüvi)',
            'Koorevigastused',
            'Puidu vigastused',
            'Eemaldatud suured oksad',
            'Oksatüükad',
            'Silelõikus',
            'Vahelekasvanud koor',
            'Kokkukasvanud harud'
        ];

        for (let field of fields) {
            let fieldName = field.replace(/ meetrites/, ', m');
            let fieldKey = toUnderscore(field.replace(/, m|, cm/, ''));
            fieldKey = fieldKey.indexOf('Puu_') === -1 ? 'Puu_' + lcfirst(fieldKey) : ucfirst(fieldKey);
            let value = this.getCustomFieldValue(fieldKey);
            if (value !== null && value !== '') {
                data.push({
                    key: fieldKey,
                    name: fieldName,
                    value: value,
                    customValue: this.getCustomFieldValue(fieldKey + "_custom"),
                });
            }
        }

        return data;
    };

    preparePlantingData = () => {
        let data = [];
        let fields = [
            'Istutamise aeg',
            'Garantiiaja lõpp',
            'Istiku päritolu. Riik',
            'Istiku päritolu. Puukool',
            'Istiku kohta märkused',
            'Kasvupinnase maht',
            'Kandev kasvualus',
            'Kasvumulla päritolu',
            'Kastmissüsteem',
            'Toestus',
            'Tüvekaitse',
            'Juurekaitse',
            'Konteiner',
            'Paljasjuurne',
            'Mullapalliga',
            'Korras',
            'Multšimine'
        ];

        for (let field of fields) {
            let fieldName = field.replace(/ meetrites/, ', m');
            let fieldKey = toUnderscore(field.replace(/\. /, ' ')).toLowerCase();
            fieldKey = fieldKey.indexOf('Puu_') === -1 ? 'Puu_' + lcfirst(fieldKey) : ucfirst(fieldKey);
            let value = this.getCustomFieldValue(fieldKey);
            if (value !== null && value !== '') {
                data.push({
                    key: fieldKey,
                    name: fieldName,
                    value: value,
                    customValue: this.getCustomFieldValue(fieldKey + "_custom"),
                });
            }
        }

        return data;
    };

    getCustomFieldValue = (customFieldName) => {
        const customField = this.props.cityObject.customFields.find(opt =>
            opt.objectTypeCustomField.objectCustomField.name === customFieldName
        );
        if (!customField) {
            return null;
        }
        let value = customField.value;
        //Fix boolean
        if (customField.objectTypeCustomField.objectCustomField.type === 'checkbox') {
            value = ['true', true, 1, '1'].indexOf(customField.value) > -1 ? '✔' : null;
        }

        return value;
    };

    render() {
        const { cityObject } = this.props;
        let parsed = queryString.parse(this.props.location.search),
            fromTender = Boolean(parsed.fromTender !== undefined);

        const baseData = this.prepareBaseData();
        const detailsData = this.prepareDetailsData();
        const juurestikData = this.prepareJuurestikData();
        const voraData = this.prepareVoraData();
        const tuviData = this.prepareTuviData();
        const plantingData = this.preparePlantingData();

        return (

            <Fragment>
                <Card>
                    <CardBody>
                        <Row>
                            <Col sm={8} xs={12}>
                                <table className="table tree-public-data-table">
                                    <thead>
                                        <tr>
                                            <th colSpan={3}><h4>Üldandmed</h4></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {baseData.map(datum =>
                                            <tr>
                                                <td>{datum.name}</td>
                                                <td>{datum.value}</td>
                                                <td>{datum.customValue}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                                <table className="table tree-public-data-table">
                                    <thead>
                                        <tr>
                                            <th colSpan={3}><h4>Olemasoleva puu andmed</h4></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {detailsData.map(datum =>
                                            <tr>
                                                <td>{datum.name}</td>
                                                <td>{datum.value}</td>
                                                <td>{datum.customValue}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                                <table className="table tree-public-data-table">
                                    <thead>
                                        <tr>
                                            <th colSpan={3}><h5>Juurestik</h5></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {juurestikData.map(datum =>
                                            <tr>
                                                <td>{datum.name}</td>
                                                <td>{datum.value}</td>
                                                <td>{datum.customValue}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                                <table className="table tree-public-data-table">
                                    <thead>
                                        <tr>
                                            <th colSpan={3}><h5>Võra</h5></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {voraData.map(datum =>
                                            <tr>
                                                <td>{datum.name}</td>
                                                <td>{datum.value}</td>
                                                <td>{datum.customValue}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                                <table className="table tree-public-data-table">
                                    <thead>
                                        <tr>
                                            <th colSpan={3}><h5>Tüvi</h5></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tuviData.map(datum =>
                                            <tr>
                                                <td>{datum.name}</td>
                                                <td>{datum.value}</td>
                                                <td>{datum.customValue}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                                <table className="table tree-public-data-table">
                                    <thead>
                                        <tr>
                                            <th colSpan={3}><h4>Istutamise andmed</h4></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {plantingData.map(datum =>
                                            <tr>
                                                <td>{datum.name}</td>
                                                <td>{datum.value}</td>
                                                <td>{datum.customValue}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </Col>
                            <Col sm={4} xs={12}>
                                {cityObject.images && (
                                    <SCarousel
                                        items={cityObject.images}
                                        defaultIndex={this.defaultIndex}
                                        alt={cityObject.name}
                                        lightbox
                                    />
                                )}
                            </Col>
                        </Row>

                        {!fromTender &&
                            <ProblemForm cityObject={cityObject} />
                        }

                    </CardBody>
                </Card>

                {cityObject.geom &&
                    <Card className='card-default p-0'>
                        <Basemap
                            rememberLayerListState={false}
                            goToOnLoad={cityObject.geom}
                        >
                            <Fullscreen />
                            <Locate />
                            {cityObject.geom.point &&
                                (cityObject.type.icon
                                    ? <PictureMarker
                                        key={cityObject.id}
                                        x={parseFloat(cityObject.geom.point.x)}
                                        y={parseFloat(cityObject.geom.point.y)}
                                        url={process.env.REACT_APP_API_V2 + "object_type/" + cityObject.type.id + "/icon.svg"
                                            + "?rand=" + new Date().getTime()
                                            + "&treeType=" + (cityObject.treeType ? cityObject.treeType.toLowerCase() : "")
                                        }
                                    />
                                    : <PointMarker
                                        key={cityObject.id}
                                        x={parseFloat(cityObject.geom.point.x)}
                                        y={parseFloat(cityObject.geom.point.y)}
                                        color={convertHex2Array(cityObject.type.color, 0.7)}
                                    />
                                )}
                        </Basemap>
                    </Card>
                }
            </Fragment>
        );
    }
}

export default withRouter(withNamespaces('common')(TreeDetails));
